export class WebhookV1StandardPayloadRestoreJobRejectedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreJobRejected",
            "baseName": "restoreJobRejected",
            "type": "WebhookV1RestoreJobRejectedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadRestoreJobRejectedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
